function Logo() {
    return <img className="logo" src={`${process.env.PUBLIC_URL || ''}/logo.svg`} alt="FastProx" />;
}

export default Logo;
